import { useEffect } from 'react';
import { selectResourceId, selectUserName, selectProfilePicture } from '../../app/auth/createAuthSlice';
import { useAppSelector } from '../../app/hooks';
import { useEnsureWelcomeNotificationMutation, useGetOrCreateChatTokenMutation } from '../../app/appApiSlice';
import ActionableCardList from './ActionableCardList';
import HomeSlider from './HomeSlider';

// Tracks the user the welcome notification was already requested for, so revisiting home does not re-post.
let welcomeNotificationRequestedForUserId: number | null = null;

const Home = () => {
const userName = useAppSelector(selectUserName);
const userProfilePicture = useAppSelector(selectProfilePicture);
const userResourceId = useAppSelector(selectResourceId);
const [getOrCreateChatToken] = useGetOrCreateChatTokenMutation();
const [ensureWelcomeNotification] = useEnsureWelcomeNotificationMutation();
const userEmail = useAppSelector((state) =>
  state.auth.appUserAccount?.data?.email ||
  state.auth.appUserAccount?.email ||
  state.auth.msGraphUser?.mail ||
  state.auth.msGraphUser?.userPrincipalName ||
  ""
);

useEffect(() => {
  const trimmedUserEmail = userEmail?.trim();
  if (!trimmedUserEmail) {
    return;
  }
  const trimmedDisplayName = userName?.trim() || undefined;
  const normalizedResourceId = typeof userResourceId === 'number' && userResourceId > 0
    ? userResourceId
    : undefined;

  getOrCreateChatToken({
    portalUserId: trimmedUserEmail,
    displayName: trimmedDisplayName,
    resourceId: normalizedResourceId,
    profilePictureUrl: userProfilePicture?.trim() || undefined,
  }).catch((error) => {
    console.error("Chat token initialization failed", error);
  });
}, [getOrCreateChatToken, userEmail, userName, userResourceId, userProfilePicture]);

useEffect(() => {
  if (typeof userResourceId !== 'number' || userResourceId <= 0) {
    return;
  }
  if (welcomeNotificationRequestedForUserId === userResourceId) {
    return;
  }
  welcomeNotificationRequestedForUserId = userResourceId;

  ensureWelcomeNotification(userResourceId).unwrap().catch((error) => {
    welcomeNotificationRequestedForUserId = null;
    console.error("Welcome notification initialization failed", error);
  });
}, [ensureWelcomeNotification, userResourceId]);

return (
    <div className=" ">
      <div>
        <h1 className="text-xl font-semibold ">
          Hi {userName || ''},  <span className=" text-brand">reconnect with your Deloitte network.</span>
        </h1>
        <p className="text-sm text-subParaText font-regular mb-5">
          Discover lifelong connections, new opportunities, and inspiring stories from the Deloitte alumni community.
        </p>
      </div>

      {/* Homepage Slider */}
      <HomeSlider />

      {/** What's New section Actionable card item list */}
    
         <ActionableCardList /> 
    </div>
  );
};

export default Home;
